/* Tarinii V4 "Beaded by hand" mechanics. Progressive enhancement: html.t-v4 is added by snippets/tarinii-motion.liquid
   before first paint; without it (no JS, reduced motion) nothing hides and nothing moves. */
(function () {
  if (!document.documentElement.classList.contains('t-v4')) return;
  var PEN = ["M50 5c25 0 45 11 45 25S75 55 50 55 5 44 5 30 25 5 50 5c9 0 17 1 24 4", "M50 55c-25 0-45-11-45-25S25 5 50 5s45 11 45 25-20 25-45 25c-9 0-17-1-24-4"];
  var STONES = ['#23201b', '#b5a3d6', '#d9782e', '#c2c94e', '#fafaf7'];
  var BEAD = function (cx, cy, r, k, force) {
    var col = force || STONES[k % STONES.length];
    var m = morphAttr(r * 2, r * 2, 9, k * 2.3 + r, 0.11, 2, 5 + (k % 3));
    return '<g class="t-bead" transform="translate(' + cx + ' ' + cy + ')"><g class="t-bead__in" style="--d:' + (k * 1.7 % 6).toFixed(1) + 's">' +
      '<g transform="translate(' + (-r).toFixed(1) + ' ' + (-r).toFixed(1) + ')"><path d="' + m.d + '" fill="' + col + '" stroke="#23201b" stroke-width="1">' + m.anim + '</path></g>' +
      '<circle cx="' + (-r * 0.34).toFixed(2) + '" cy="' + (-r * 0.34).toFixed(2) + '" r="' + (r * 0.24).toFixed(2) + '" fill="#fff" opacity=".45"/></g></g>';
  };
  var isHome = document.body.classList.contains('template-index');
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  // --- hand-drawn shapes that never sit still: one generator, three variants, morphed forever ---
  var SNS = 'http://www.w3.org/2000/svg';
  var rnd = function (s) { var x = Math.sin(s * 127.1) * 43758.5453; return x - Math.floor(x); };
  var orgPath = function (w, h, n, seed, amp, pw) {
    var pts = [], i;
    for (i = 0; i < n; i++) {
      var a = i / n * Math.PI * 2, ca = Math.cos(a), sa = Math.sin(a);
      var ex = (ca < 0 ? -1 : 1) * Math.pow(Math.abs(ca), 2 / pw);
      var ey = (sa < 0 ? -1 : 1) * Math.pow(Math.abs(sa), 2 / pw);
      var jit = 1 + amp * (Math.sin(seed * 1.7 + i * 2.1) * 0.6 + Math.sin(seed * 0.9 + i * 3.7) * 0.4 + (rnd(seed + i) - 0.5) * 0.5);
      pts.push([w / 2 + (w / 2 - 1) * ex * jit, h / 2 + (h / 2 - 1) * ey * jit]);
    }
    var f = function (v) { return v.toFixed(1); };
    var d = 'M' + f(pts[0][0]) + ' ' + f(pts[0][1]);
    for (i = 0; i < n; i++) {
      var p0 = pts[(i - 1 + n) % n], p1 = pts[i], p2 = pts[(i + 1) % n], p3 = pts[(i + 2) % n];
      d += ' C' + f(p1[0] + (p2[0] - p0[0]) / 6) + ' ' + f(p1[1] + (p2[1] - p0[1]) / 6) +
           ' ' + f(p2[0] - (p3[0] - p1[0]) / 6) + ' ' + f(p2[1] - (p3[1] - p1[1]) / 6) +
           ' ' + f(p2[0]) + ' ' + f(p2[1]);
    }
    return d + 'Z';
  };
  var morphAttr = function (w, h, n, seed, amp, pw, dur) {
    var a = orgPath(w, h, n, seed, amp, pw), b = orgPath(w, h, n, seed + 3.3, amp, pw), c2 = orgPath(w, h, n, seed + 7.1, amp, pw);
    return { d: a, anim0: '<animate attributeName="d" dur="' + dur + 's" repeatCount="indefinite" calcMode="spline" keyTimes="0;0.33;0.66;1" keySplines=".45 0 .55 1;.45 0 .55 1;.45 0 .55 1" values="' + a + ';' + b + ';' + c2 + ';' + a + '"/>', anim: '' };
  };
  var penLoop = function (seed, turns, scale) {
    // the same hand as the thread down the side, wrapped round the words
    var f = function (v) { return v.toFixed(1); };
    turns = turns || 1.12; scale = scale || 1;
    var steps = Math.round(64 * turns), pts = [], i;
    for (i = 0; i <= steps; i++) {
      var t = i / steps * turns, a = t * Math.PI * 2 - Math.PI * 0.12 - seed * 0.3;
      var wob = 1 + 0.055 * Math.sin(seed * 1.3 + t * 7.4) + 0.034 * Math.sin(seed * 2.7 + t * 17.9) + 0.02 * Math.sin(t * 39.1 + seed);
      var drift = t * 1.6;
      pts.push([50 + 44 * scale * Math.cos(a) * wob + drift, 30 + 23.5 * scale * Math.sin(a) * wob + drift * 0.3]);
    }
    var d = 'M' + f(pts[0][0]) + ' ' + f(pts[0][1]);
    for (i = 1; i < pts.length - 1; i++) {
      var cx = (pts[i][0] + pts[i + 1][0]) / 2, cy = (pts[i][1] + pts[i + 1][1]) / 2;
      d += ' Q' + f(pts[i][0]) + ' ' + f(pts[i][1]) + ' ' + f(cx) + ' ' + f(cy);
    }
    return d;
  };
  var gidN = 0;
  var dressShape = function (el, opts) {
    if (el.querySelector('.t-scribble')) return;
    var seed = (el.textContent || '').length * 3.7 + (gidN * 1.9) + 1;
    var m = morphAttr(100, 60, opts.n || 11, seed, opts.amp || 0.05, opts.pw || 3.2, opts.dur || 9);
    var svg = document.createElementNS(SNS, 'svg');
    svg.setAttribute('class', 't-scribble' + (opts.cls ? ' ' + opts.cls : ''));
    svg.setAttribute('viewBox', '0 0 100 60'); svg.setAttribute('preserveAspectRatio', 'none'); svg.setAttribute('aria-hidden', 'true');
    var fill = 'none', defs = '';
    if (opts.fill) { var gid = 't-g' + (gidN++); defs = '<defs><linearGradient id="' + gid + '" x1="0" y1="0" x2="1" y2="1"><stop offset="0" class="t-gs1"/><stop offset="1" class="t-gs2"/></linearGradient></defs>'; fill = 'url(#' + gid + ')'; }
    svg.innerHTML = defs + '<path d="' + m.d + '" fill="' + fill + '" stroke="' + (opts.stroke === false ? 'none' : 'currentColor') + '" stroke-width="' + (opts.sw || 1.4) + '" stroke-linejoin="round" vector-effect="non-scaling-stroke">' + m.anim + '</path>';
    el.appendChild(svg); el.classList.add('t-has-scribble');
  };

  // header height as a CSS var (the hero is pulled up under it on the homepage)
  var header = document.querySelector('.t-header');
  function setHeaderH() { if (header) document.documentElement.style.setProperty('--t-header-h', header.offsetHeight + 'px'); }
  setHeaderH(); window.addEventListener('resize', setHeaderH);

  // 1. images develop inside a stone: every image frame gets the mask, released once fully grown
  var frames = document.querySelectorAll('.t-card__media, .t-fband__main, .t-fband__small, .t-fband__sq, .t-pdp__slide, .t-imgbanner__media, .t-gallery__item, .t-eduo__tile .t-card__media, .t-opener__media, .t-page__body img');
  if ('IntersectionObserver' in window) {
    frames.forEach(function (el) { el.classList.add('t-rv'); });
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target; el.classList.add('t-rv-in');
        setTimeout(function () { el.classList.add('t-rv-done'); }, 1200);
        io.unobserve(el);
      });
    }, { rootMargin: '-8% 0px' });
    frames.forEach(function (el) { io.observe(el); });
  }

  // 2. magnetic drift on cards (Elhanati): --dx/--dy = pointer offset from the card centre
  if (fine) {
    document.querySelectorAll('.t-card').forEach(function (c) {
      c.addEventListener('pointermove', function (e) {
        var r = c.getBoundingClientRect(); c.classList.add('is-active');
        c.style.setProperty('--dx', (e.clientX - r.left - r.width / 2) + 'px');
        c.style.setProperty('--dy', (e.clientY - r.top - r.height / 2) + 'px');
      });
      c.addEventListener('pointerleave', function () { c.classList.remove('is-active'); c.style.setProperty('--dx', '0px'); c.style.setProperty('--dy', '0px'); });
    });
  }

  // 3. hero line settles letter by letter (the words are untouched)
  var line = document.querySelector('.t-herofull__line');
  if (line && !line.querySelector('i')) {
    var i = 0;
    // letters are inline-blocks, so each word gets a nowrap group or a phone can break inside it ("b / y")
    line.innerHTML = line.textContent.trim().split(/\s+/).map(function (word) {
      return '<span style="white-space:nowrap">' + word.split('').map(function (ch) { return '<i style="--i:' + (i++) + '">' + ch + '</i>'; }).join('') + '</span>';
    }).join(' ');
  }

  // 4. header over the hero: transparent at the top of the homepage, paper after one viewport
  if (isHome && header) {
    var hero = document.querySelector('.t-herofull');
    var over = function () { header.classList.toggle('is-over', hero && window.scrollY < hero.offsetHeight - header.offsetHeight); };
    over(); window.addEventListener('scroll', over, { passive: true });
  }

  // 5. the thread: a line down the left margin drawn by scroll, one bead strung at each section (home). desktop: in the left margin; phone and tablet: the same line scaled down into the gutter
  var mainEl = document.querySelector('main') || document.body;
  if (mainEl.querySelectorAll('.shopify-section').length >= 3) {
    var main = mainEl;
    var svgNS = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(svgNS, 'svg'); svg.setAttribute('class', 't-thread'); svg.setAttribute('aria-hidden', 'true');
    svg.style.display = 'block'; // tarinii-v4.css hides .t-thread under 990px; the gutter version below replaces that
    var P = document.createElementNS(svgNS, 'path'); P.setAttribute('class', 't-thread__p');
    var G = document.createElementNS(svgNS, 'g'); G.setAttribute('class', 't-thread__beads');
    svg.appendChild(P); svg.appendChild(G); main.insertBefore(svg, main.firstChild);
    var sections = Array.prototype.slice.call(main.querySelectorAll('.t-statement, .t-featured, .t-fband, .t-eduo, .t-imgbanner, .t-news, .t-textcols, .t-quote, .t-cols, .t-gallery'));
    var len = 0, pts = [], startY = 0, mainTop = 0, lastW = 0;
    function layout() {
      mainTop = main.getBoundingClientRect().top + window.scrollY;
      var H = main.scrollHeight; svg.setAttribute('height', H); svg.setAttribute('width', window.innerWidth); svg.setAttribute('viewBox', '0 0 ' + window.innerWidth + ' ' + H);
      lastW = window.innerWidth;
      var K = lastW < 750 ? 0.3 : lastW < 990 ? 0.55 : 1; // how far the line may wander: phone gutter is 18px, tablet 32px
      var x0 = lastW < 750 ? 9 : lastW < 990 ? 16 : 34;
      pts = sections.map(function (s, k) { var r = s.getBoundingClientRect(); return { x: x0 + (k % 2 ? 7 : -5) * K, y: r.top + window.scrollY - mainTop + Math.min(r.height * .38, 420) }; });
      var heroEl = document.querySelector('.t-herofull');
      startY = heroEl ? heroEl.offsetTop + heroEl.offsetHeight + 10 : 120;
      var wob = function (yy) { return K * 9 * Math.sin(yy / 150) + K * 5 * Math.sin(yy / 57 + 1.7) + K * 2.5 * Math.sin(yy / 24 + 0.4); };
      var LOOPS = [
        function (x, py, ex, K) { return ' C' + (x + 34 * K) + ' ' + (py - 40) + ' ' + (x + 44 * K) + ' ' + (py + 4) + ' ' + (x + 6 * K) + ' ' + (py + 10) +
          ' C' + (x - 32 * K) + ' ' + (py + 16) + ' ' + (x - 38 * K) + ' ' + (py - 26) + ' ' + (x - 2 * K) + ' ' + (py - 18) +
          ' C' + (x + 20 * K) + ' ' + (py - 12) + ' ' + (x + 12 * K) + ' ' + (py + 26) + ' ' + ex + ' ' + (py + 44); },
        function (x, py, ex, K) { return ' C' + (x + 30 * K) + ' ' + (py - 34) + ' ' + (x + 32 * K) + ' ' + (py - 6) + ' ' + x + ' ' + py +
          ' C' + (x - 32 * K) + ' ' + (py + 6) + ' ' + (x - 30 * K) + ' ' + (py + 34) + ' ' + ex + ' ' + (py + 44); },
        function (x, py, ex, K) { return ' C' + (x + 18 * K) + ' ' + (py - 30) + ' ' + (x + 26 * K) + ' ' + (py - 8) + ' ' + (x + 4 * K) + ' ' + (py - 4) +
          ' C' + (x - 16 * K) + ' ' + py + ' ' + (x - 12 * K) + ' ' + (py + 18) + ' ' + (x + 6 * K) + ' ' + (py + 16) +
          ' C' + (x + 20 * K) + ' ' + (py + 14) + ' ' + (x + 10 * K) + ' ' + (py + 32) + ' ' + ex + ' ' + (py + 44); },
        function (x, py, ex, K) { return ' C' + (x - 42 * K) + ' ' + (py - 36) + ' ' + (x - 54 * K) + ' ' + (py + 8) + ' ' + (x - 10 * K) + ' ' + (py + 14) +
          ' C' + (x + 28 * K) + ' ' + (py + 19) + ' ' + (x + 18 * K) + ' ' + (py + 30) + ' ' + ex + ' ' + (py + 44); },
        function (x, py, ex, K) { return ' C' + (x + 22 * K) + ' ' + (py - 36) + ' ' + (x + 28 * K) + ' ' + (py - 14) + ' ' + (x + 2 * K) + ' ' + (py - 12) +
          ' C' + (x - 20 * K) + ' ' + (py - 10) + ' ' + (x - 18 * K) + ' ' + (py + 6) + ' ' + (x + 4 * K) + ' ' + (py + 6) +
          ' C' + (x + 24 * K) + ' ' + (py + 6) + ' ' + (x + 22 * K) + ' ' + (py + 26) + ' ' + (x - 2 * K) + ' ' + (py + 26) +
          ' C' + (x - 18 * K) + ' ' + (py + 26) + ' ' + (x - 8 * K) + ' ' + (py + 38) + ' ' + ex + ' ' + (py + 44); },
        function (x, py, ex, K) { return ' C' + (x + 36 * K) + ' ' + (py - 30) + ' ' + (x - 32 * K) + ' ' + (py - 6) + ' ' + (x - 26 * K) + ' ' + (py + 8) +
          ' C' + (x - 20 * K) + ' ' + (py + 24) + ' ' + (x + 36 * K) + ' ' + (py + 6) + ' ' + (x + 16 * K) + ' ' + (py - 6) +
          ' C' + (x + 4 * K) + ' ' + (py - 15) + ' ' + (x - 6 * K) + ' ' + (py + 30) + ' ' + ex + ' ' + (py + 44); }
      ];
      var d = 'M' + (x0 + wob(startY)) + ' ' + startY, yy = startY, pi = 0;
      while (yy < H - 40) {
        if (pi < pts.length && yy >= pts[pi].y - 40) { d += ' L' + pts[pi].x + ' ' + (pts[pi].y - 40) + LOOPS[pi % LOOPS.length](pts[pi].x, pts[pi].y, x0 + wob(pts[pi].y + 44), K); yy = pts[pi].y + 44; pi++; continue; }
        yy += 20; d += ' L' + (x0 + wob(yy)) + ' ' + yy;
      }
      P.setAttribute('d', d); len = P.getTotalLength(); P.style.strokeDasharray = len; P.style.strokeDashoffset = len;
      G.innerHTML = '';
      draw();
    }
    function draw() {
      if (!len) return;
      var reach = window.scrollY + window.innerHeight * .72 - mainTop;
      var total = pts.length ? pts[pts.length - 1].y + 200 : 1;
      var prog = Math.min(1, Math.max(0, (reach - startY) / (total - startY)));
      P.style.strokeDashoffset = len * (1 - prog);
      Array.prototype.forEach.call(G.children, function (b, k) { b.classList.toggle('on', pts[k] && pts[k].y < reach); });
    }
    window.addEventListener('scroll', draw, { passive: true }); window.addEventListener('resize', function () { if (window.innerWidth !== lastW) layout(); }); // phone toolbars fire resize while scrolling
    window.addEventListener('load', function () { setTimeout(layout, 300); }); setTimeout(layout, 1200);
  }

  // 6. a short length of thread lying on the page. the pointer drags it along, and it catches as it goes.
  var shopPage = location.pathname === '/' || /\/(collections|products)(\/|$)/.test(location.pathname);
  if (false) { // cursor thread removed 2026-09-25
    var ns = 'http://www.w3.org/2000/svg';
    var B = document.createElementNS(ns, 'svg'); B.setAttribute('class', 't-beads'); B.setAttribute('aria-hidden', 'true');
    var T = document.createElementNS(ns, 'path'); T.setAttribute('class', 't-beads__thread'); B.appendChild(T);
    document.body.appendChild(B); B.classList.add('is-on');
    var N = 15, LINK = 9, DAMP = 0.74, ITER = 5, GRAB = 74, thread = [];
    var startX = Math.round(window.innerWidth * 0.22), startY = Math.round(window.innerHeight * 0.62);
    for (var ti = 0; ti < N; ti++) {
      var x0 = startX + ti * LINK, y0 = startY + Math.sin(ti * 0.5) * 3;
      thread.push({ x: x0, y: y0, px: x0, py: y0 });
    }
    var mx = -999, my = -999, held = -1;
    window.addEventListener('pointermove', function (e) { mx = e.clientX; my = e.clientY; }, { passive: true });
    document.addEventListener('mouseleave', function () { mx = -999; my = -999; held = -1; });
    (function tick() {
      var W = window.innerWidth, Hh = window.innerHeight, i, p;
      // the pointer catches the nearest part of the thread when it comes close, and lets go when it wanders off
      var best = -1, bestD = GRAB;
      for (i = 0; i < N; i++) {
        var dd = Math.hypot(thread[i].x - mx, thread[i].y - my);
        if (dd < bestD) { bestD = dd; best = i; }
      }
      if (held < 0) held = best; else if (Math.hypot(thread[held].x - mx, thread[held].y - my) > GRAB * 1.9) held = best;
      for (i = 0; i < N; i++) {
        p = thread[i];
        var vx = (p.x - p.px) * DAMP, vy = (p.y - p.py) * DAMP;
        p.px = p.x; p.py = p.y; p.x += vx; p.y += vy;
      }
      if (held >= 0) {
        // it catches rather than snaps: the caught point eases toward the pointer, a little slower than the pointer moves
        thread[held].x += (mx - thread[held].x) * 0.3;
        thread[held].y += (my - thread[held].y) * 0.3;
      }
      for (var it = 0; it < ITER; it++) {
        for (i = 0; i < N - 1; i++) {
          var a = thread[i], b = thread[i + 1];
          var dx = b.x - a.x, dy = b.y - a.y, d = Math.hypot(dx, dy) || 0.001;
          var diff = (d - LINK) / d * 0.5, ox = dx * diff, oy = dy * diff;
          var wa = (i === held) ? 0.15 : 1, wb = (i + 1 === held) ? 0.15 : 1;
          a.x += ox * wa; a.y += oy * wa; b.x -= ox * wb; b.y -= oy * wb;
        }
      }
      for (i = 0; i < N; i++) {
        p = thread[i];
        if (p.x < 6) { p.x = 6; p.px = p.x; } else if (p.x > W - 6) { p.x = W - 6; p.px = p.x; }
        if (p.y < 6) { p.y = 6; p.py = p.y; } else if (p.y > Hh - 6) { p.y = Hh - 6; p.py = p.y; }
      }
      // sample along the chain and push each sample sideways, so the line wanders like the one drawn down the side
      var samp = [], SUB = 4;
      for (var m = 0; m < N - 1; m++) {
        for (var sI = 0; sI < SUB; sI++) {
          var u = sI / SUB, ax = thread[m].x, ay = thread[m].y, bx2 = thread[m + 1].x, by2 = thread[m + 1].y;
          var sx = ax + (bx2 - ax) * u, sy = ay + (by2 - ay) * u;
          var tx = bx2 - ax, ty = by2 - ay, tl = Math.hypot(tx, ty) || 1;
          var nx = -ty / tl, ny = tx / tl, s = m + u;
          var off = 1.5 * Math.sin(s * 1.9) + 0.9 * Math.sin(s * 4.7 + 1.3) + 0.45 * Math.sin(s * 9.1);
          samp.push([sx + nx * off, sy + ny * off]);
        }
      }
      samp.push([thread[N - 1].x, thread[N - 1].y]);
      var d2 = 'M' + samp[0][0].toFixed(1) + ' ' + samp[0][1].toFixed(1);
      for (var q2 = 1; q2 < samp.length - 1; q2++) {
        d2 += ' Q' + samp[q2][0].toFixed(1) + ' ' + samp[q2][1].toFixed(1) + ' ' +
          ((samp[q2][0] + samp[q2 + 1][0]) / 2).toFixed(1) + ' ' + ((samp[q2][1] + samp[q2 + 1][1]) / 2).toFixed(1);
      }
      d2 += ' L' + samp[samp.length - 1][0].toFixed(1) + ' ' + samp[samp.length - 1][1].toFixed(1);
      T.setAttribute('d', d2);
      window.requestAnimationFrame(tick);
    })();
  }

  // 7y. the rail the pieces hang from: the same hand as the thread down the side, sagging under its own weight
  document.querySelectorAll('[data-hung]').forEach(function (rail) {
    var svg = rail.querySelector('[data-hung-thread]'), path = rail.querySelector('[data-hung-path]');
    if (!svg || !path) return;
    var draw = function () {
      var w = rail.clientWidth, h = svg.clientHeight || 96, n = 84, d = '', drop = h * 0.5;
      svg.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
      for (var i = 0; i <= n; i++) {
        var t = i / n, x = t * w;
        var y = 4 + drop * Math.sin(Math.PI * t) + 2.2 * Math.sin(1.7 + t * 19) + 1.3 * Math.sin(3.1 + t * 44);
        d += (i ? ' L' : 'M') + x.toFixed(1) + ' ' + y.toFixed(1);
      }
      path.setAttribute('d', d);
    };
    draw(); window.addEventListener('resize', draw); window.addEventListener('load', draw);
  });

  // the price is circled by hand when you look at a piece
  document.querySelectorAll('.t-hung__item .t-price').forEach(function (el, i) {
    if (el.querySelector('.t-scribble')) return;
    var s = document.createElementNS(SNS, 'svg');
    s.setAttribute('class', 't-scribble t-scribble--pen t-scribble--price');
    s.setAttribute('viewBox', '0 0 100 60'); s.setAttribute('preserveAspectRatio', 'none'); s.setAttribute('aria-hidden', 'true');
    s.innerHTML = '<path d="' + penLoop(i + 6.2, 1.1, 0.98) + '" pathLength="1" fill="none" stroke="currentColor" stroke-width="1.05" stroke-linecap="round" vector-effect="non-scaling-stroke"/>';
    el.appendChild(s); el.classList.add('t-has-scribble');
  });

  // 7z. the pen is measured in real pixels, so the line keeps the same quality on a wide button and a single letter
  var penIn = function (w, h, seed, turns, grow) {
    var f = function (v) { return v.toFixed(1); };
    var cx = w / 2, cy = h / 2, rx = w / 2 - 2 - grow, ry = h / 2 - 2 - grow;
    var steps = Math.round(54 * turns), pts = [], i;
    for (i = 0; i <= steps; i++) {
      var t = i / steps * turns, ang = t * Math.PI * 2 - Math.PI * 0.15 - seed * 0.4;
      var wx = 0.7 * Math.sin(seed * 1.3 + t * 7.4) + 0.4 * Math.sin(seed * 2.7 + t * 17.9) + 0.22 * Math.sin(t * 38 + seed);
      var wy = 0.55 * Math.sin(seed * 2.1 + t * 9.3) + 0.32 * Math.sin(seed * 1.4 + t * 23.7);
      pts.push([cx + (rx + wx) * Math.cos(ang) + t * 0.6, cy + (ry + wy) * Math.sin(ang) + t * 0.35]);
    }
    var p = 'M' + f(pts[0][0]) + ' ' + f(pts[0][1]);
    for (i = 1; i < pts.length - 1; i++) p += ' Q' + f(pts[i][0]) + ' ' + f(pts[i][1]) + ' ' + f((pts[i][0] + pts[i + 1][0]) / 2) + ' ' + f((pts[i][1] + pts[i + 1][1]) / 2);
    return p;
  };
  var penCircle = function (el, o) {
    var pad = o.pad || [26, 16], seed = o.seed || 1.7;
    var build = function () {
      var w = el.offsetWidth + pad[0], h = el.offsetHeight + pad[1];
      if (!w || !h) return;
      var svg = el.querySelector('.t-scribble--pen');
      if (!svg) { svg = document.createElementNS(SNS, 'svg'); svg.setAttribute('class', 't-scribble t-scribble--pen' + (o.cls ? ' ' + o.cls : '')); svg.setAttribute('aria-hidden', 'true'); el.appendChild(svg); el.classList.add('t-has-scribble'); }
      svg.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
      svg.style.cssText = 'position:absolute;left:' + (-pad[0] / 2) + 'px;top:' + (-pad[1] / 2) + 'px;width:' + w + 'px;height:' + h + 'px;overflow:visible;pointer-events:none;z-index:-1';
      svg.innerHTML = '<path class="t-pen1" d="' + penIn(w, h, seed, o.turns || 1.05, 0) + '" pathLength="1" fill="none" stroke="currentColor" stroke-width="' + (o.sw || 1.15) + '" stroke-linecap="round"/>' +
        (o.second ? '<path class="t-pen2" d="' + penIn(w, h, seed + 4.1, 1.02, -2) + '" pathLength="1" fill="none" stroke="currentColor" stroke-width="' + ((o.sw || 1.15) - 0.25) + '" stroke-linecap="round"/>' : '');
    };
    build();
    var t2; window.addEventListener('resize', function () { clearTimeout(t2); t2 = setTimeout(build, 180); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(build);
  };

  // the buy button is circled at rest, and circled again when the pointer arrives
  document.querySelectorAll('.t-pdp__add, .t-stickybar__add').forEach(function (el, i) {
    penCircle(el, { seed: i + 1.9, pad: [20, 12], turns: 1.02, sw: 0.9 });
  });
  document.querySelectorAll('.t-chip, .t-oval').forEach(function (el, i) {
    penCircle(el, { seed: i + 5.3, pad: [12, 8], turns: 1.02, sw: 0.85, cls: 't-scribble--chip' });
  });


  // 7a. press rows: a stone scribbles around the outlet name on hover
  document.querySelectorAll('.t-press__pub').forEach(function (pub, k) {
    var s = document.createElementNS('http://www.w3.org/2000/svg', 'svg'); s.setAttribute('class', 't-pdp__stone'); s.setAttribute('viewBox', '0 0 100 60'); s.setAttribute('preserveAspectRatio', 'none'); s.setAttribute('aria-hidden', 'true');
    s.innerHTML = '<path d="' + penLoop(k + 2.7, 1.16, 0.99) + '" pathLength="1" fill="none" stroke="currentColor" stroke-width="1.05" stroke-linecap="round" vector-effect="non-scaling-stroke"/>';
    pub.appendChild(s);
  });

  // 7b. every size can be circled: the chosen one is drawn, the one under the pointer is drawn faintly
  document.querySelectorAll('.t-pdp__size').forEach(function (lab, k) {
    if (lab.classList.contains('is-soldout')) return;
    penCircle(lab, { seed: k + 2.6, pad: [12, 9], turns: 1.03, sw: 0.85, cls: 't-scribble--size' });
  });


  // 7. add to cart answers in place: no reload, label swaps, view-cart link appears, the count stone bumps (Vestige)
  var form = document.getElementById('tarinii-add');
  if (form && window.fetch) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('.t-pdp__add'), sticky = document.querySelector('.t-stickybar__add');
      var label = function (t) { if (btn) btn.textContent = t; if (sticky) sticky.textContent = t; };
      var fd = new FormData(form); fd.delete('return_to');
      label('adding...');
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return fetch('/cart.js').then(function (c) { return c.json(); }); })
        .then(function (cart) {
          label('added');
          var count = document.querySelector('[data-cart-count]');
          var vc = form.querySelector('.t-pdp__viewcart'); if (vc) vc.hidden = false;
          // a bead drops out of the button and flies up into the bag stone, which catches it
          var from = (btn || form).getBoundingClientRect(), to = count ? count.getBoundingClientRect() : null;
          if (btn) { btn.classList.add('is-wobble'); setTimeout(function () { btn.classList.remove('is-wobble'); }, 700); }
          var settle = function () {
            if (count) { count.textContent = cart.item_count; count.classList.add('t-circle--fill', 'is-bump'); setTimeout(function () { count.classList.remove('is-bump'); }, 500); }
            if (window.__tBeads) window.__tBeads.grow();
          };
          if (to && document.body.animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            var bead = document.createElement('i'); bead.className = 't-flybead'; bead.innerHTML = '<svg viewBox="-9 -9 18 18" overflow="visible">' + BEAD(0, 0, 7, 2) + '</svg>';
            document.body.appendChild(bead);
            var sx = from.left + from.width / 2, sy = from.top + from.height / 2, ex = to.left + to.width / 2, ey = to.top + to.height / 2;
            var mx2 = (sx + ex) / 2, my2 = Math.min(sy, ey) - 160;
            var anim = bead.animate([
              { transform: 'translate(' + sx + 'px,' + sy + 'px) scale(.6)', opacity: 1 },
              { transform: 'translate(' + mx2 + 'px,' + my2 + 'px) scale(1.4) rotate(120deg)', opacity: 1, offset: .5 },
              { transform: 'translate(' + ex + 'px,' + ey + 'px) scale(.7) rotate(260deg)', opacity: 1 }
            ], { duration: 760, easing: 'cubic-bezier(.3,.6,.3,1)', fill: 'forwards' });
            anim.onfinish = function () { bead.remove(); settle(); };
          } else settle();
          setTimeout(function () { label((btn && btn.getAttribute('data-label')) || 'add to cart'); }, 1600);
        })
        .catch(function () { form.submit(); });
    });
  }
})();
